<div *ngIf="!dashboardLoaded" class="k-pos-absolute k-top k-left k-right k-bottom" fxLayout="row"
     fxLayoutAlign="center center">
  <kendo-loader size="medium" themeColor="primary" type="pulsing"></kendo-loader>
</div>
<div fxFlex id="dashboardContainer"></div>
